<template>
    <div>
        <relatorio :pparms="{ id: id }" :inportal="true" />
    </div>
</template>

<script>
import Relatorio from '../relatorios/Relatorio.vue';

export default {
  props: ['id'], 

  components: { 
    Relatorio,
  },
}
</script>
